import cn from 'clsx';

/**
 * @description This component is used to render the fixed content bottom on mobile
 */
const MobileFixedContent: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  return (
    <div
      className={cn(
        'tw-w-full',
        // Fixed to bottom on mobile
        'tw-fixed tw-bottom-0 tw-left-0 sm:tw-relative',
        // Padding on mobile
        'tw-px-2 tw-pt-1.2 tw-pb-2.4 sm:tw-p-0',
        // Z-index on mobile
        'tw-z-7 sm:tw-z-auto',
        // Background color on mobile
        'tw-bg-neutral-light-100 sm:tw-bg-transparent',
      )}
    >
      {children}
    </div>
  );
};

export default MobileFixedContent;
